import {fromJS, Map} from "immutable";

const snakeToCamelCase = function(key) {
  // first_name -> firstName, isbn_10 -> isbn10, scores_a_1 -> scoresA1
  return key.replace(/(_+[a-z0-9])/g, function (snip) {
    return snip.toUpperCase().replace("_", "");
  });    
}


// Server errors about the action as a whole rather than any one field. Keyed to
// a field no form has, they would otherwise vanish behind the generic message,
// so they become the form's own error instead.
//
// order_driven: the shipment is being driven by an automated flow (a
// subscription or a checkout) and refuses changes until that flow finishes.
// msg: the backend's general key for a failure that belongs to no field.
const FORM_LEVEL_KEYS = ["order_driven", "msg"];

const isFormLevel = (error) => FORM_LEVEL_KEYS.includes(error.get("key"));

export function createValidationErrors(errors, message = "An error occured") {
  let data = fromJS(errors);
  let result = data.filterNot(isFormLevel).reduce((acc, x) => {
    return acc.set(snakeToCamelCase(x.get("key")), x.get("message"));
  }, Map());
  let formLevel = data.filter(isFormLevel);
  let formMessage = formLevel.isEmpty() ? message : formLevel.map((x) => x.get("message")).join(" ");
  return result.set("_error", formMessage).toJS();
}

export function createErrors(err) {
  return {_error: String(err)}
}
